import { render } from "./carBodyReleaseDialog.vue?vue&type=template&id=b6aab3a4&scoped=true"
import script from "./carBodyReleaseDialog.vue?vue&type=script&lang=js"
export * from "./carBodyReleaseDialog.vue?vue&type=script&lang=js"

import "./carBodyReleaseDialog.vue?vue&type=style&index=0&id=b6aab3a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6aab3a4"]])

export default __exports__